// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__gZOdn","footer":"ReportModalFilter_footer__3e6TO"};